import axios from 'axios';
import fileDownload from 'js-file-download';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getEvent(store) {
    const { commit, state } = store;
    return await axios({
      url: `/v1/events/${state.event.id}?include=users,files,notifications_policies`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setEventUsers', resp.data.data.users.data);
        commit('setEventFiles', resp.data.data.files.data);
        commit('setEvent', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async getEventSkills(store) {
    const { commit, state} = store;
    return await axios({
      url: `/v1/events/${state.event.id}/skills/list`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setEventSkills', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addSkillToEvent(store, skillID) {
    const { state, dispatch } = store;
    return await axios({
      url: `/v1/events/${state.event.id}/skills`,
      method: 'POST',
      data: { skills: [skillID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getEventSkills');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteSkillFromEvent(store, skill) {
    const { state, dispatch } = store;
    return await axios({
      url: `/v1/events/${state.event.id}/skills`,
      method: 'DELETE',
      data: { skills: [skill.id] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getEventSkills');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addUserToEvent(store, data) {
    const { state, dispatch } = store;
    return await axios({
      url: `/v1/events/${state.event.id}/users/${data.userID}`,
      method: 'POST',
      data: { ...data.request },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getEvent');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteUserFromEvent(store, user) {
    const { state, dispatch } = store;
    return await axios({
      url: `/v1/events/${state.event.id}/users/${user.id}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getEvent');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async getEmployees(store) {
    const { commit, getters, rootState } = store;
    const { page, per_page } = rootState.misc.pagination;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/employees/list?page=${page}&per_page=${per_page}&include=organizations,fnd&${getters['employeeFilter']}`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setEmployees', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async setNotificationPolicy(store, { type, policy }) {
    const { commit, rootState } = store;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/notifications/policies`,
      method: 'POST',
      data: { type, policy }
    })
      .then(resp => {
        if (resp.data && resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setNotificationPolicy', { type, policy });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async createNotification(store, message) {
    const { rootState } = store;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/notifications`,
      method: 'POST',
      data: { message }
    })
      .then(resp => {
        if (resp.data && resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async importEvent(store, {users_file, projects_file}) {
    const { rootState } = store;
    const formData = new FormData();
    formData.append('users_file', users_file);
    formData.append('projects_file', projects_file);
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/import`,
      method: 'POST',
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      data: formData,
    })
      .then(resp => {
        if (resp.data && resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async createReport(store, { report_type, start_date, finish_date }) {
    const { rootState } = store;
    if (report_type !== 'general' && report_type !== 'detailed') {
      return Promise.reject({
        message: 'Указан неверный тип отчета. Обратитесь к администратору',
        validation: {},
      });
    }
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/reports/${report_type}`,
      method: 'POST',
      data: { start_date, finish_date },
      responseType: 'blob',
    })
      .then(resp => {
        if (resp.data && resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        fileDownload(resp.data, `${rootState.events.event.short_name} - отчет.pdf`);
        return Promise.resolve();
      })
      .catch(parseApiError);
  },
};

export default actions;